/* eslint-env browser */
/* global google */
(function () {
  "use strict";

  var DEFAULT_API_BASE = "https://reg.mainstevents.com";
  var AUTOSAVE_DELAY_MS = 2000;

  function normalizeApiBase(base) {
    if (!base) return DEFAULT_API_BASE;
    try {
      var resolved = new URL(base, window.location.origin);
      return (resolved.origin + resolved.pathname).replace(/\/$/, "");
    } catch (err) {
      console.warn("FLAIR registration: invalid API base", base, err);
      return DEFAULT_API_BASE;
    }
  }

  function resolveApiBase(root) {
    var base =
      (root && root.dataset && root.dataset.apiBase) ||
      (typeof window !== "undefined" && window.FLAIR_API_BASE) ||
      DEFAULT_API_BASE;

    if (window.location.protocol === "https:" && /^http:\/\//i.test(base)) {
      console.warn("FLAIR registration: refusing insecure API base on https page", base);
    }
    return normalizeApiBase(base);
  }

  function safeStringify(value) {
    try {
      return JSON.stringify(value);
    } catch (err) {
      return "";
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll(".flair-reg:not([data-initialized])");
    for (var i = 0; i < roots.length; i++) {
      initOne(roots[i]);
      roots[i].setAttribute("data-initialized", "true");
    }
  }

  function initOne(root) {
    var form = root.querySelector("#flairRegForm");
    if (!form) return;

    /* -------- autosave session setup -------- */
    var apiBase = resolveApiBase(root);
    var showCodeEl = form.elements["show_code"];
    var showSlugEl = form.elements["show_slug"];
    var showCode = showCodeEl ? (showCodeEl.value || "").trim() : "";
    var showSlug = showSlugEl ? (showSlugEl.value || "").trim() : "";
    var showKey = showCode || showSlug || "default";
    var storageKey = "flair_reg_resume_" + showKey;

    var resumeToken = sessionStorage.getItem(storageKey) || null;
    var autosaveArmed = !!resumeToken;
    var autosaveTimer = null;
    var lastAutosaveSignature = "";
    var submitting = false;

    /* -------- original selectors -------- */
    var progressEl = root.querySelector(".flair-reg__progress");
    var rail = root.querySelector(".flair-reg__progress-rail");
    var bar = root.querySelector(".flair-reg__progress-bar");
    var stepLabelEl = root.querySelector(".flair-reg__step-label");
    var steps = Array.prototype.slice.call(root.querySelectorAll(".flair-step"));
    var totalSteps = steps.length;
    var currentStepIndex = 0;

    var attendeesWrap = form.querySelector("[data-attendees]");
    var othersToggle = form.querySelectorAll("input[name='has_others']");
    var othersCountWrap = form.querySelector("[data-others-count]");
    var othersCountEl = form.querySelector("input[name='others_count']");
    var msgEl = root.querySelector("#flairRegMsg");
    var addressInput = form.querySelector("[data-address-autocomplete]");
    var addressHidden = form.querySelector("[data-sync-hidden='address1']");
    var submitBtn = form.querySelector('[type="submit"]');

    /* -------- helpers -------- */
    function setHidden(name, val) {
      var el = form.elements[name];
      if (!el) {
        el = document.createElement("input");
        el.type = "hidden";
        el.name = name;
        form.appendChild(el);
      }
      el.value = val == null ? "" : String(val);
    }

    function updateResumeParam(token) {
      try {
        var url = new URL(window.location.href);
        if (token) {
          url.searchParams.set("resume", token);
        } else {
          url.searchParams.delete("resume");
        }
        window.history.replaceState({}, "", url.toString());
      } catch (err) {
        /* ignore */
      }
    }

    function storeResumeToken(token) {
      if (!token) return;
      resumeToken = token;
      autosaveArmed = true;
      sessionStorage.setItem(storageKey, token);
      setHidden("resume_token", token);
      updateResumeParam(token);
    }

    function clearResumeToken() {
      resumeToken = null;
      autosaveArmed = false;
      sessionStorage.removeItem(storageKey);
      setHidden("resume_token", "");
      updateResumeParam(null);
    }

    function armAutosave(event) {
      if (autosaveArmed) return;
      if (event && event.isTrusted === false) return;
      autosaveArmed = true;
    }

    function captureUTM() {
      var qs = new URLSearchParams(location.search);
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (k) {
        var v = qs.get(k) || localStorage.getItem(k) || "";
        if (v) localStorage.setItem(k, v);
        setHidden(k, v);
      });
    }

    function ensureSession() {
      var t = localStorage.getItem("flair_reg_session");
      if (!t) {
        t = window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random();
        localStorage.setItem("flair_reg_session", t);
      }
      setHidden("session_token", t);
      return t;
    }

    function syncAddressHidden() {
      if (addressInput && addressHidden) addressHidden.value = addressInput.value || "";
    }

    if (addressInput) {
      addressInput.addEventListener("input", syncAddressHidden);
      addressInput.addEventListener("change", syncAddressHidden);
      addressInput.style.setProperty("-webkit-text-security", "none", "important");
      addressInput.style.setProperty("text-security", "none", "important");
    }

    var textSecurityGuard = setInterval(function () {
      if (!document.body.contains(root)) {
        clearInterval(textSecurityGuard);
        return;
      }
      if (addressInput) {
        addressInput.style.setProperty("-webkit-text-security", "none", "important");
        addressInput.style.setProperty("text-security", "none", "important");
      }
    }, 800);

    var titles = [
      "Register Your Store",
      "Store Address",
      "Tell Us About Your Store",
      "Register Additional Team Members"
    ];

    function setProgress() {
      var frac = totalSteps ? (currentStepIndex + 1) / totalSteps : 0;
      var pctValue = Math.max(0, Math.min(100, frac * 100));
      var pctString = pctValue + "%";

      if (rail) {
        rail.style.setProperty("--p", String(frac));
        rail.style.setProperty("--progress", pctString);
        rail.setAttribute("data-progress-frac", String(frac));
      }
      if (bar) {
        bar.style.setProperty("--p", String(frac));
        bar.style.setProperty("--progress", pctString);
        bar.style.width = pctString;
      }
      if (progressEl) progressEl.setAttribute("aria-valuenow", String(Math.round(pctValue)));
      if (stepLabelEl) {
        stepLabelEl.innerHTML =
          "Step <strong>" + (currentStepIndex + 1) + "</strong> of <strong>" + totalSteps + "</strong> — " + (titles[currentStepIndex] || "");
      }
    }

    function scrollStepIntoView() {
      var progressRect = root.querySelector(".flair-reg__progress");
      var scrollOffset = 60;
      var targetElement = progressRect || steps[currentStepIndex];
      var targetRect = targetElement.getBoundingClientRect();
      var targetTop = targetRect.top + window.pageYOffset - scrollOffset;
      var scrollOptions = { top: Math.max(0, targetTop), behavior: "smooth" };
      try {
        window.scrollTo(scrollOptions);
      } catch (_) {
        window.scrollTo(0, Math.max(0, targetTop));
      }
    }

    function focusFirstField() {
      var focusables = steps[currentStepIndex].querySelectorAll("input:not([type='hidden']), textarea, select, button");
      var first = null;
      for (var f = 0; f < focusables.length; f++) {
        var el = focusables[f];
        if (el.disabled) continue;
        if (el.tagName === "SELECT") continue;
        first = el;
        break;
      }
      if (!first && focusables.length) first = focusables[0];
      if (first && typeof first.focus === "function") {
        try {
          first.focus({ preventScroll: true });
        } catch (e) {
          first.focus();
        }
      }
    }

    function showStep(index) {
      var idx = Math.max(0, Math.min(index, totalSteps - 1));
      for (var s = 0; s < steps.length; s++) steps[s].hidden = s !== idx;
      currentStepIndex = idx;
      setProgress();
      scrollStepIntoView();
      focusFirstField();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "flair_form_step", step: currentStepIndex + 1, event_id: "STEP-" + Date.now() });

      scrubTextSecurity(root);
      syncAddressHidden();
      scheduleAutosave("step");
    }

    function validateStep(index) {
      var fs = steps[index];
      var required = fs.querySelectorAll("[required]");
      for (var i = 0; i < required.length; i++) {
        var el = required[i];
        var bad = !el.value || (el.type === "email" && !/\S+@\S+\.\S+/.test(el.value));
        if (bad) {
          el.focus();
          el.setAttribute("aria-invalid", "true");
          if (msgEl) msgEl.textContent = "Please complete the required fields.";
          return false;
        } else {
          el.removeAttribute("aria-invalid");
        }
      }
      if (msgEl) msgEl.textContent = "";
      return true;
    }

    function hasOthersYes() {
      var yesRadio = form.querySelector("input[name='has_others'][value='Yes']");
      return !!(yesRadio && yesRadio.checked);
    }

    function toggleOthersCount() {
      if (!othersCountWrap) return;
      var show = hasOthersYes();
      othersCountWrap.hidden = !show;
      othersCountWrap.setAttribute("aria-hidden", show ? "false" : "true");
      if (othersCountWrap.classList) othersCountWrap.classList.toggle("is-hidden", !show);
      if (!show && othersCountEl) othersCountEl.value = "0";
    }

    function renderAttendees() {
      if (!attendeesWrap) return;
      var n = 0;
      if (hasOthersYes() && othersCountEl) {
        var v = parseInt(othersCountEl.value || "0", 10);
        if (!isNaN(v)) n = Math.min(10, Math.max(0, v));
      }
      attendeesWrap.innerHTML = "";
      for (var i = 1; i <= n; i++) {
        var firstId = "attendee-" + i + "-first";
        var lastId = "attendee-" + i + "-last";
        var emailId = "attendee-" + i + "-email";

        var block = document.createElement("div");
        block.className = "attendee-block";
        block.setAttribute("data-guest-index", String(i));

        block.innerHTML =
          '<div class="f-grid">' +
          '<label class="f-field">' +
          "<span>First name</span>" +
          '<input id="' + firstId + '" name="attendee_' + i + '_first" placeholder="First name">' +
          "</label>" +
          '<label class="f-field">' +
          "<span>Last name</span>" +
          '<input id="' + lastId + '" name="attendee_' + i + '_last" placeholder="Last name">' +
          "</label>" +
          '<label class="f-field">' +
          "<span>Email</span>" +
          '<input id="' + emailId + '" name="attendee_' + i + '_email" type="email" inputmode="email" placeholder="email@domain.com">' +
          "</label>" +
          "</div>";

        attendeesWrap.appendChild(block);
      }
    }

    function getParam(name) {
      var m = new RegExp("[?&]" + name + "=([^&]+)").exec(window.location.search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null;
    }

    function setField(name, val) {
      var el = form.elements[name];
      if (!el) return;
      if (el instanceof RadioNodeList) {
        var list = Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]'));
        list.forEach(function (n) {
          if (n.type === "checkbox") {
            if (Array.isArray(val)) n.checked = val.indexOf(n.value) !== -1;
          } else if (n.type === "radio") {
            n.checked = String(n.value) === String(val);
          }
        });
        return;
      }
      if (el.tagName === "SELECT") el.value = val ?? "";
      else if (el.type === "checkbox") el.checked = !!val;
      else el.value = val ?? "";
    }

    function hydrateFromDraft(draft) {
      if (!draft) return;
      var payload = draft.payload || {};
      [
        "company",
        "email",
        "first_name",
        "last_name",
        "phone",
        "address1",
        "address2",
        "city",
        "region",
        "postal_code",
        "country",
        "store_phone",
        "show_code",
        "show_slug",
        "others_count",
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_content",
        "utm_term"
      ].forEach(function (k) {
        if (payload[k] != null) setField(k, payload[k]);
      });

      if (Array.isArray(payload.categories)) {
        var boxes = form.querySelectorAll('input[name="categories[]"]');
        boxes.forEach(function (b) {
          b.checked = payload.categories.indexOf(b.value) !== -1;
        });
      }

      if (payload.has_others === "Yes" || payload.has_others === "No") {
        setField("has_others", payload.has_others);
      }

      if (Array.isArray(payload.guests) && payload.guests.length) {
        var guests = payload.guests;
        var n = Math.min(10, guests.length);
        setField("others_count", String(n));
        toggleOthersCount();
        renderAttendees();
        for (var i = 0; i < n; i++) {
          var g = guests[i] || {};
          var idx = g.guest_index || i + 1;
          var f = form.elements["attendee_" + idx + "_first"];
          var l = form.elements["attendee_" + idx + "_last"];
          var e = form.elements["attendee_" + idx + "_email"];
          if (f) f.value = g.first_name || "";
          if (l) l.value = g.last_name || "";
          if (e) e.value = g.email || "";
        }
      }

      var disp = form.querySelector('[name="address1_display"]');
      if (disp && !disp.value && payload.address1) disp.value = payload.address1;
      syncAddressHidden();

      var stepIndex = typeof draft.step_index === "number" ? draft.step_index : 0;
      stepIndex = Math.max(0, Math.min(stepIndex, steps.length - 1));
      showStep(stepIndex);

      if (msgEl) msgEl.textContent = "We restored your saved progress.";
    }

    function scrubTextSecurity(scope) {
      if (!scope) return;
      var fields = scope.querySelectorAll(".f-field input, .f-field textarea");
      for (var i = 0; i < fields.length; i++) {
        try {
          fields[i].style.setProperty("-webkit-text-security", "none", "important");
          fields[i].style.setProperty("text-security", "none", "important");
        } catch (err) {
          /* no-op */
        }
      }
    }

    function waitForPlaces(cb) {
      var tries = 0;
      var iv = setInterval(function () {
        if (window.google && google.maps && google.maps.places) {
          clearInterval(iv);
          cb();
          return;
        }
        if (++tries > 100) clearInterval(iv);
      }, 100);
    }

    function attachPlaces() {
      if (!addressInput) return;
      var ac = new google.maps.places.Autocomplete(addressInput, {
        types: ["address"],
        fields: ["address_components", "formatted_address", "geometry"]
      });

      ac.addListener("place_changed", function () {
        var place = ac.getPlace();
        if (!place || !place.address_components) return;

        function part(type) {
          var comps = place.address_components || [];
          for (var i = 0; i < comps.length; i++) {
            if (comps[i].types && comps[i].types.indexOf(type) !== -1) {
              return comps[i].long_name || "";
            }
          }
          return "";
        }

        var streetNumber = part("street_number");
        var route = part("route");
        var address1 = (streetNumber ? streetNumber + " " : "") + (route || "");
        if (address1) addressInput.value = address1;
        syncAddressHidden();

        var cityEl = form.elements["city"];
        var regionEl = form.elements["region"];
        var zipEl = form.elements["postal_code"];
        var countryEl = form.elements["country"];

        if (cityEl) cityEl.value = part("locality") || part("sublocality") || part("postal_town") || "";
        if (regionEl) regionEl.value = part("administrative_area_level_1") || "";
        if (zipEl) zipEl.value = part("postal_code") || "";
        if (countryEl) countryEl.value = part("country") || "";
      });
    }

    /* -------- autosave helpers -------- */
    function serializePayload() {
      syncAddressHidden();

      var fd = new FormData(form);
      var payload = {};
      fd.forEach(function (value, key) {
        if (key === "categories[]") return;
        if (payload[key] !== undefined) {
          if (!Array.isArray(payload[key])) payload[key] = [payload[key]];
          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      });

      var categories = fd
        .getAll("categories[]")
        .map(function (v) {
          return (v || "").toString().trim();
        })
        .filter(Boolean);
      if (categories.length) payload.categories = categories;

      var count = parseInt(payload.others_count || "0", 10);
      if (isNaN(count)) count = 0;
      count = Math.max(0, Math.min(count, 10));

      var guests = [];
      for (var i = 1; i <= count; i++) {
        var f = (payload["attendee_" + i + "_first"] || "").trim();
        var l = (payload["attendee_" + i + "_last"] || "").trim();
        var e = (payload["attendee_" + i + "_email"] || "").trim();
        if (f || l || e) {
          guests.push({ first_name: f || null, last_name: l || null, email: e || null, guest_index: i });
        }
        delete payload["attendee_" + i + "_first"];
        delete payload["attendee_" + i + "_last"];
        delete payload["attendee_" + i + "_email"];
      }
      if (guests.length) payload.guests = guests;
      else delete payload.guests;

      payload.address1 = payload.address1 || payload.address1_display || "";
      delete payload.address1_display;

      payload.show_code = payload.show_code || showCode;
      if (!payload.show_slug && showSlug) payload.show_slug = showSlug;
      if (resumeToken) payload.resume_token = resumeToken;

      return payload;
    }

    function currentProgressFraction() {
      if (!totalSteps) return null;
      return Math.max(0, Math.min(1, (currentStepIndex + 1) / totalSteps));
    }

    function scheduleAutosave(reason) {
      if (submitting || !autosaveArmed) return;
      clearTimeout(autosaveTimer);
      autosaveTimer = setTimeout(function () {
        autosaveNow(reason);
      }, AUTOSAVE_DELAY_MS);
    }

    function autosaveNow(reason) {
      var payload = serializePayload();
      var signature = safeStringify({ payload: payload, step_index: currentStepIndex });
      if (signature && signature === lastAutosaveSignature) return;
      lastAutosaveSignature = signature;

      var body = {
        show_code: payload.show_code || payload.show_slug || "",
        email: (payload.email || "").trim() || null,
        step: currentStepIndex + 1,
        progress: currentProgressFraction(),
        resume_token: resumeToken,
        guest_count: Array.isArray(payload.guests) ? payload.guests.length : null,
        data: {
          payload: payload,
          step_index: currentStepIndex,
          reason: reason || null
        }
      };

      if (!body.show_code) return;

      fetch(apiBase + "/api/registration-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (json) {
          if (json && json.ok && json.resume_token) storeResumeToken(json.resume_token);
        })
        .catch(function (err) {
          console.warn("FLAIR autosave failed", err);
        });
    }

    function normalizeDraftData(session) {
      if (!session) return null;
      var raw = session.data || session;
      if (typeof raw === "string") {
        try {
          raw = JSON.parse(raw);
        } catch (err) {
          raw = null;
        }
      }
      if (!raw || typeof raw !== "object") return null;
      if (raw.payload) return raw;
      return { payload: raw, step_index: raw.step_index || 0 };
    }

    function loadDraft(token) {
      if (!token) return Promise.resolve();
      return fetch(apiBase + "/api/registration-session?token=" + encodeURIComponent(token), {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (json) {
          if (!json || !json.ok || !json.session) return;
          storeResumeToken(json.session.resume_token || token);
          var draft = normalizeDraftData(json.session);
          hydrateFromDraft(draft);
          lastAutosaveSignature = "";
          scheduleAutosave("hydrate");
        })
        .catch(function (err) {
          console.warn("FLAIR resume load failed", err);
        });
    }

    function finalizeSession() {
      if (!resumeToken) return Promise.resolve();
      return fetch(apiBase + "/api/registration-session/" + encodeURIComponent(resumeToken) + "/finalize", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      }).catch(function (err) {
        console.warn("FLAIR finalize failed", err);
      });
    }

    /* -------- events -------- */
    form.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" || e.defaultPrevented) return;
      var target = e.target;
      if (!target) return;
      var tag = target.tagName;
      if (tag === "TEXTAREA" || target.isContentEditable) return;
      if (tag === "BUTTON") return;
      if (tag === "INPUT") {
        var type = (target.type || "").toLowerCase();
        if (type === "submit" || type === "button") return;
      }
      if (currentStepIndex < totalSteps - 1) {
        e.preventDefault();
        if (!validateStep(currentStepIndex)) return;
        showStep(currentStepIndex + 1);
      }
    });

    form.addEventListener("click", function (e) {
      var next = e.target.closest && e.target.closest("[data-next]");
      var prev = e.target.closest && e.target.closest("[data-prev]");
      if (next) {
        if (!validateStep(currentStepIndex)) return;
        if (currentStepIndex === 0) {
          var nowIso = new Date().toISOString();
          var mo = form.elements["marketing_opt_in"];
          var cv = form.elements["consent_version"];
          var ca = form.elements["consented_at"];
          if (mo) mo.value = "true";
          if (cv && !cv.value) cv.value = "flair-reg-v1";
          if (ca) ca.value = nowIso;
        }
        if (currentStepIndex < totalSteps - 1) showStep(currentStepIndex + 1);
      }
      if (prev) {
        if (currentStepIndex > 0) showStep(currentStepIndex - 1);
      }
    });

    for (var r = 0; r < othersToggle.length; r++) {
      othersToggle[r].addEventListener("change", function (event) {
        armAutosave(event);
        toggleOthersCount();
        if (hasOthersYes()) renderAttendees();
        else if (attendeesWrap) attendeesWrap.innerHTML = "";
        scheduleAutosave("toggle_guests");
      });
    }

    if (othersCountEl) {
      othersCountEl.addEventListener("input", function (event) {
        armAutosave(event);
        renderAttendees();
        scheduleAutosave("guest_count");
      });
    }

    form.addEventListener("input", function (event) {
      armAutosave(event);
      scheduleAutosave("input");
    });

    form.addEventListener("change", function (event) {
      armAutosave(event);
      scheduleAutosave("change");
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!validateStep(currentStepIndex)) return;

      submitting = true;
      clearTimeout(autosaveTimer);

      var payload = serializePayload();
      var params = new URLSearchParams(location.search);
      if (!payload.show_code) {
        payload.show_code = params.get("show") || showCode || showSlug || "";
      }
      if (!payload.show_code && !payload.show_slug) {
        if (msgEl) msgEl.textContent = "Missing show code — configure it in the section settings.";
        submitting = false;
        return;
      }
      if (resumeToken) payload.resume_token = resumeToken;

      if (submitBtn) submitBtn.disabled = true;

      fetch(apiBase + "/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (body) {
          if (!body || body.ok === false) {
            var errMsg = body && body.error ? body.error : "Registration failed";
            var stepMsg = body && body.step ? " [" + body.step + "]" : "";
            if (msgEl) msgEl.textContent = "Registration failed: " + errMsg + stepMsg;
            throw new Error(errMsg);
          }

          console.log("DEBUG FLAIR: success handler reached", { payload: payload });

          // ----- Tracking: completed registration -----
          var metaEventId =
            (window.crypto && crypto.randomUUID)
              ? crypto.randomUUID()
              : "REG-" + Date.now() + "-" + Math.random();

          var showCodeForTracking = payload.show_code || payload.show_slug || "";

          // 1) Dedicated complete-registration event with rich data
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "flair_complete_registration",
            event_id: metaEventId,
            show_code: showCodeForTracking,
            role: "buyer",
            email: (payload.email || "").trim() || null,
            first_name: (payload.first_name || "").trim() || null,
            last_name: (payload.last_name || "").trim() || null,
            city: (payload.city || "").trim() || null,
            region: (payload.region || "").trim() || null,
            country: (payload.country || "").trim() || null
          });

          // 2) Keep your existing generic form-submit event (same event_id)
          window.dataLayer.push({
            event: "flair_form_submit",
            event_id: metaEventId,
            lead_type: "buyer_registration",
            lead_origin: "shopify_registration_section",
            show_code: showCodeForTracking
          });

          // ----- Existing UX behavior -----
          if (msgEl) msgEl.textContent = "Thanks! Your registration has been received.";
          form.reset();
          if (attendeesWrap) attendeesWrap.innerHTML = "";
          toggleOthersCount();
          renderAttendees();
          syncAddressHidden();
          showStep(0);
          clearResumeToken();
          lastAutosaveSignature = "";
          return finalizeSession();
        })
        .catch(function (err) {
          if (!msgEl.textContent) msgEl.textContent = "Network error submitting registration.";
          console.error(err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
          submitting = false;
        });
    });

    /* -------- init -------- */
    captureUTM();
    ensureSession();
    scrubTextSecurity(root);
    toggleOthersCount();
    renderAttendees();
    syncAddressHidden();

    var resumeParam = getParam("resume");
    if (resumeParam) storeResumeToken(resumeParam);
    else if (resumeToken) setHidden("resume_token", resumeToken);

    if (resumeToken) {
      loadDraft(resumeToken).finally(function () {
        if (!resumeToken) showStep(0);
      });
    } else {
      showStep(0);
    }

    if (addressInput) waitForPlaces(attachPlaces);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
